import { YearPicker } from '@repo/go-ui';
import { clsx } from 'clsx';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { TFieldRulesData, TYearOnlyPickerView } from 'src/services/directory-service/types';

import styles from './year-only-picker-component.module.scss';

type Props = {
  fieldView: TYearOnlyPickerView;
  value: number | null;
  error?: string;
  fieldRulesData?: TFieldRulesData;
  className?: string;
  onChange(fieldId: string, value: unknown): void;
  onBlur?(fieldId: string): void;
};

export const YearOnlyPickerComponent = wrap<Props>(function YearOnlyPickerComponent({
  fieldView,
  value,
  fieldRulesData,
  error,
  className,
  onChange,
  onBlur,
}) {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (value: number | null) => onChange?.(fieldView.fieldId, value),
    [fieldView.fieldId, onChange],
  );

  const handleBlur = useCallback(() => onBlur?.(fieldView.fieldId), [fieldView.fieldId, onBlur]);

  return (
    <YearPicker
      value={value}
      disabled={fieldRulesData?.isDisabled || fieldRulesData?.isEnteringBlocked}
      status={error ? 'error' : undefined}
      placeholder={t('common:placeholders.chooseYear')}
      className={clsx(styles.field, className)}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
});
